export const SoundDeviceType = {
    INPUT: 'audioinput',
    OUTPUT: 'audiooutput',
};
